var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMonitor = function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.656 5.333h2.188v7.778h-2.188V5.333ZM8.47 20.89c0 .295-.115.577-.32.786a1.085 1.085 0 0 1-.774.325H4.094c-.29 0-.569-.117-.774-.325a1.12 1.12 0 0 1-.32-.786v-5.556l2.188-10h4.375v7.778c0 .295-.116.577-.32.786a1.085 1.085 0 0 1-.774.325v6.667ZM9.563 4.222H6.28V2h3.282v2.222ZM15.03 20.89v-6.667c-.29 0-.568-.117-.773-.325a1.12 1.12 0 0 1-.32-.786V5.333h4.374l2.188 10v5.556c0 .295-.115.577-.32.786a1.085 1.085 0 0 1-.774.325h-3.281c-.29 0-.568-.117-.773-.325a1.12 1.12 0 0 1-.32-.786ZM13.937 4.222V2h3.282v2.222h-3.282Z"
  })));
};
export default SvgMonitor;